export default {"src":"/_next/static/image/public/assets/feature-images/fr/grammar.4130ba7f2ab7d78c8b38f647bcaef59c.svg","height":382,"width":520};